import { FC } from 'react'

import { useParams } from '@tanstack/react-router'

import { Card, CardContent, Cluster, Grid, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'

import { BookingOverviewTabLayout } from '../BookingLayout'

export const BookingDetailsTitleSkeleton: FC = () => {
  return (
    <Cluster gap={8} y="center" fullWidth>
      <Skeleton variant="icon" />
      <Stack fullWidth gap={4}>
        <Grid col={8}>
          <Skeleton variant="badge" fullWidth />
        </Grid>
        <Skeleton variant="content" />
      </Stack>
    </Cluster>
  )
}

export const BookingDetailsSkeleton: FC = () => {
  const { id } = useParams({
    from: '/bookings/$id/details',
  })
  return (
    <BookingOverviewTabLayout
      sidebar={
        <Stack gap={16}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Cluster key={index} gap={8} y="center">
              <Skeleton variant="icon" />
              <Skeleton variant="button" fullWidth />
            </Cluster>
          ))}
        </Stack>
      }
      title={<BookingDetailsTitleSkeleton />}
      main={
        <Stack gap={16}>
          <Card>
            <CardContent>
              <Stack gap={16}>
                <Grid col={4} gap={8}>
                  <Skeleton variant="badge" fullWidth />
                </Grid>
                <Grid col={6} gap={16}>
                  {Array.from({ length: 10 }).map((_, index) => (
                    <Skeleton key={index} variant="content" size={8} fullWidth />
                  ))}
                </Grid>
              </Stack>
            </CardContent>
          </Card>
          <Grid col={2} gap={16}>
            {Array.from({ length: 2 }).map((_, index) => (
              <Card key={index}>
                <CardContent>
                  <Stack gap={16}>
                    <Grid col={3}>
                      <Skeleton variant="badge" fullWidth />
                    </Grid>
                    <Grid col={3} gap={8}>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <Skeleton key={index} variant="button" fullWidth />
                      ))}
                    </Grid>
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Grid>
          <Card>
            <CardContent>
              <Stack gap={16}>
                <Grid col={4} gap={8}>
                  <Skeleton variant="badge" fullWidth />
                </Grid>
                <Cluster gap={24}>
                  <Skeleton variant="content" size={8} />
                  <Skeleton variant="content" size={8} />
                </Cluster>
                <Cluster gap={24}>
                  <Skeleton variant="content" size={8} />
                  <Skeleton variant="content" size={8} />
                </Cluster>
                <Cluster gap={24}>
                  <Skeleton variant="content" size={8} />
                  <Skeleton variant="content" size={8} />
                  <Skeleton variant="content" size={8} />
                </Cluster>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      }
      bookingId={id}
    />
  )
}
